<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<div class="_idGenObjectLayout-1">
<div class="Image-Spread" id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-4" src="image/tortilla4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-2">
<div class="caption-Spreads" id="_idContainer004">
<p class="body_Caption-Spread">Mexican Pulled Pork in Birria Tacos p.138</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MakingVeganMeat-4.vue?32d153da